import { BaseRecord } from "./BaseRecord";
import { Tenant } from "./Tenant";

export class Category extends BaseRecord<number> {
    public name: string;

    public tenantId !: number;
    public tenant: Tenant | null;
    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.tenantId = 0;
        this.tenant = new Tenant();
    }
}
